import { createSlice } from '@reduxjs/toolkit';
import { emptyBidderDetailsSlice } from './bidderProfile.types';
import { fetchBidderProfile, updateBidderProfile } from './bidderProfile.actions';

const bidderProfileSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchBidderProfile.pending, (slice) => {
            slice.loading = true;
            slice.error = false;
            slice.submitted = false;
        });
        builder.addCase(fetchBidderProfile.fulfilled, (slice, { payload }) => {
            slice.bidderDetails = payload;
            slice.loading = false;
            slice.error = false;
        });
        builder.addCase(fetchBidderProfile.rejected, (slice, { payload }) => {
            slice.error = true;
            slice.success = false;
            slice.submitted = false;
            slice.errorMessage = payload.message;
        });
        builder.addCase(updateBidderProfile.pending, (slice) => {
            slice.loading = true;
            slice.error = false;
            slice.submitted = true;
        });
        builder.addCase(updateBidderProfile.fulfilled, (slice) => {
            slice.loading = false;
            slice.error = false;
        });
        builder.addCase(updateBidderProfile.rejected, (slice, { payload }) => {
            slice.error = true;
            slice.success = false;
            slice.submitted = false;
            slice.errorMessage = payload.message;
        });
    },
    initialState: emptyBidderDetailsSlice,
    name: 'bidderProfileSlice',
    reducers: {},
});

export const { reducer: bidderProfileSliceReducer } = bidderProfileSlice;
